import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export const NoUnreadMessages = () => (
  <div className="flex size-full flex-col items-center justify-start pt-12">
    <Typography variant="label-sm">{t("messaging.no_messages")}</Typography>
  </div>
);
